// extracted by mini-css-extract-plugin
export default {"heading-primary":"Wrapper_heading-primary__xqMun","wrapper":"Wrapper_wrapper__zFk5x"};